// Education levels grouped by curriculum, for the student forms.
// The stored value is the plain level ('Y1', 'P1'), so levels that exist in
// more than one curriculum save the same value. The field stays free-text:
// anything not listed can simply be typed in.
export const EDUCATION_LEVEL_GROUPS = [
  {
    curriculum: 'British School',
    levels: [
      'Nursery',
      'Reception',
      'Y1',
      'Y2',
      'Y3',
      'Y4',
      'Y5',
      'Y6',
      'Y7',
      'Y8',
      'Y9',
      'Y10',
      'Y11',
      'Y12',
      'Y13',
    ],
  },
  {
    curriculum: 'American Curriculum',
    levels: [
      'Pre-Kindergarten',
      'Kindergarten',
      'G1',
      'G2',
      'G3',
      'G4',
      'G5',
      'G6',
      'G7',
      'G8',
      'G9',
      'G10',
      'G11',
      'G12',
    ],
  },
  {
    curriculum: 'Australian School',
    levels: [
      'Pre-School',
      'Foundation Year',
      'Y1',
      'Y2',
      'Y3',
      'Y4',
      'Y5',
      'Y6',
      'Y7',
      'Y8',
      'Y9',
      'Y10',
      'Y11',
      'Y12',
    ],
  },
  {
    curriculum: 'Singapore School',
    levels: [
      'N1',
      'N2',
      'K1',
      'K2',
      'P1',
      'P2',
      'P3',
      'P4',
      'P5',
      'P6',
      'S1',
      'S2',
      'S3',
      'S4',
      'S5',
    ],
  },
  {
    curriculum: 'University Level',
    levels: [
      'Foundation',
      'Diploma',
      'Bachelor’s Degree',
      'Postgraduate Diploma',
      'Master’s Degree',
      'Doctoral Degree / PhD',
    ],
  },
  {
    curriculum: 'Thai School Level',
    levels: [
      'Pre-Kindergarten',
      'K1',
      'K2',
      'K3',
      'P1',
      'P2',
      'P3',
      'P4',
      'P5',
      'P6',
      'M1',
      'M2',
      'M3',
      'M4',
      'M5',
      'M6',
    ],
  },
];

// Shape antd's Select/AutoComplete expects for grouped options
export const EDUCATION_LEVEL_OPTIONS = EDUCATION_LEVEL_GROUPS.map((group) => ({
  label: group.curriculum,
  options: group.levels.map((level) => ({ value: level, label: level })),
}));

// Every level once, for anywhere that needs a flat list
export const EDUCATION_LEVELS = [
  ...new Set(EDUCATION_LEVEL_GROUPS.flatMap((group) => group.levels)),
];

export default EDUCATION_LEVEL_GROUPS;
